import React, { useEffect,useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle, PhoneCall } from 'lucide-react';
import imagen1 from '../assets/images/FAQPage/FAQpageimg1.webp'
import imagen2 from '../assets/images/FAQPage/FAQpageimg2.webp'

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const FAQPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const images = [imagen1, imagen2];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [images.length]);
  const particles = Array.from({ length: 40 });

  const faqs = [
    {
      question: "¿Cómo solicito una cotización?",
      answer: "A lo largo de la plataforma, se encuentran varios métodos para efectuar una cotización (uso de carrito, llamada directa a equipo comercial, emisión de correo formal a correos indexos en la página de contactanos, etc), más sin embargo, se recomienda dar un primer contacto con nuestro equipo comercial desde la página de contactanos, esto con el fin de garantizar cotizaciones sujetas a disponibilidad en stock (salvo venta previa), y así pactar tiempos de entrega y demás en caso tal de que el volumen del pedido sea considerable."
    },
    {
      question: "¿Que horarios manejan para el despliegue de despachos y operaciones?",
      answer: "Se tienen hoarios comprendidos para despachos de Lunes a Viernes 9:00 AM - 4:00 PM. Tener en cuenta que toda coordinación de pedidos se debe efectuar hasta antes de las 2:00 PM de Lunes a Viernes, pasada dicha hora se entendera como pedido del día posterior. Todo cambio se hará efectivo dentro de los 8 días posteriores a la entrega del producto (sujeta a evaluación). Finalmente tener en cuenta que por compras mayores a $ 250.000,00 COP el envío es gratuito (de lo contrario se efectuará cobro a flete)."
    },
    {
      question: "¿Con qué certificaciones cuentan sus productos?",
      answer: "Todos nuestros productos cuentan con certificaciones internacionales como IEC, ASTM, ANSI y cumplen con las normativas colombianas. Cada producto incluye su certificado de conformidad y calidad correspondiente (según sea el caso)."
    },
    {
      question: "¿Ofrecen garantía en sus equipos?",
      answer: "Sí, ofrecemos garantía bajo termino legal de 12 meses en todos nuestros productos contra defectos de fabricación, excepto cuando se afirme otro tipo de vigencia. Al recepcionar un producto por servicio post-venta se efectuará un análisis durante los 7 días posteriores (hábiles) con el objetivo de dar un veredicto sobre su aplicación o No de grantía."
    },
    {
      question: "¿Que hay de las devoluciones de productos?",
      answer: "Para que las devoluciones sean admitidas, los productos deben ser devueltos a nuestras instalaciones en perfectas condiciones. Tener en cuenta que para realizar la solicitud de devolución, se deberá efectuar la novedad dentro de los primeros 15 días desde la entrega del producto (Vencido dicho plazo NO se admitirán devoluciones); en caso tal de que la solititud sea conforme o no, usted recibirá el estado del tramite vía correo electrónico (en horas hábiles) en un plazo máximo de 72 horas."
    },
    {
      question: "¿Realizan pruebas dieléctricas, verificación y calibración de equipos?",
      answer: "Contamos con laboratorios acreditados por ONAC para el desarrollo de las distintas pruebas a efectuar en elementos de naturaleza dieléctrica (Fibra de vidrio, poliester, caucho, etc) y equipos de medición como multímetros, megóhmetros y equipos de detección con trazabilidad a patrones nacionales."
    },
    {
      question: "¿Cuál es el tiempo de entrega de los productos?",
      answer: "Para productos en stock, el tiempo de entrega es de 1-3 días hábiles si las condiciones proporcionadas por el cliente no son variables. Para productos especiales o importados, el tiempo puede variar entre 30 a 45 días. Por lo anterior, recomendamos formalmente a nuestro nicho de interes el efectuar solicitudes de pedido con un previo estudio de disponibilidad de la mano de nuestro equipo comercial y así minimizar tardanzas en nuestros despachos."
    },
    {
      question: "¿Brindan capacitación en el uso de equipos?",
      answer: "Sí, ofrecemos capacitación técnica especializada con modalidad presencial y/o virtual (según requerimiento) en el uso correcto de equipos de protección personal y herramientas - dispositivos para TCT. Contamos con profesionales certificados para este servicio."
    },
    {
      question: "¿Manejan equipos para todas las tensiones eléctricas?",
      answer: "Tenemos equipos para trabajos en baja, media y alta tensión. Desde 70V hasta 230kV, con diferentes clases de aislamiento y sistemas de protección según la aplicación específica."
    },
    {
      question: "¿Realizan mantenimiento de equipos de otras marcas?",
      answer: "Depente, nuestro equipo técnico especializado puede realizar mantenimiento preventivo y correctivo de equipos eléctricos de cualquier marca reconocida unica y exclusivamente si está bajo jurisdicción nuetras en alguno de los procesos o proyectos gestionados."
    },
    {
      question: "¿Tienen servicio técnico 24/7?",
      answer: "Para servicios regulares, nuestro horario es de lunes a viernes de 7:30 AM a 5:00 PM, sabados de 8:30 AM a 12:00 pm."
    },
    {
      question: "¿Cómo sé qué equipo de protección necesito?",
      answer: "Nuestro primer filtro de selección viene siendo el canal directo con nuestros asesores comerciales, en caso tal de escalar el tema, remitirse con el equipo de ingeniería. En cualquier caso, podrán asesorarte en la selección correcta de EPPs y dispositivos según tu aplicación específica, nivel de tensión y normativas aplicables. Contáctanos por tu consulta gratuita."
    },
    {
      question: "¿Ofrecen crédito para compras empresariales?",
      answer: "Depende, ya que en efecto se debe ejercer un estudio predemeditado del perfil credicticio y así definir términos y condiciones"
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="relative min-h-screen py-12 overflow-hidden">
      {/* SLIFER FADE */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0">
          {images.map((img, index) => {
            const isActive = index === currentIndex;

            return (
              <motion.div
                key={index}
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${img})` }}
                initial={{ opacity: 0, scale: 1.02, filter: "blur(8px)" }}
                animate={
                  isActive
                    ? {
                      opacity: 1,
                      scale: 1,
                      filter: "blur(0px)"
                    }
                    : {
                      opacity: 0,
                      scale: 1.05,
                      filter: "blur(6px)"
                    }
                }
                transition={{
                  duration: 2.5,
                  ease: [0.4, 0, 0.2, 1] // easing crossfade cinematográfico
                }}
              />
            );
          })}
        </div>

        {/* OVERLAY GRADIENTE (SUAVIZADO ARRIBA → ABAJO) */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-black/70 to-black z-10" />

        {/* PARTICULAS SUAVES */}
        <div className="absolute inset-0 pointer-events-none z-20">
          {particles.map((_, i) => {
            const size = Math.random() * 10 + 8;
            const left = Math.random() * 100;
            const duration = Math.random() * 5 + 5;
            const delay = Math.random() * 10;

            return (
              <motion.div
                key={i}
                className="absolute rounded-full bg-blue-300/80 blur-sm shadow-lg shadow-blue-400/60"
                style={{
                  width: size,
                  height: size,
                  left: `${left}%`,
                  bottom: "-100px"
                }}
                initial={{ y: 0 }}
                animate={{ y: -1200 }}
                transition={{
                  duration: duration,
                  repeat: Infinity,
                  ease: "linear",
                  delay: delay
                }}
              />
            );
          })}
        </div>
      </div>

      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl shadow-gray-700">
            <HelpCircle className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r text-white bg-clip-text text-transparent">
            Preguntas Frecuentes
          </h1>
          <p className="text-white max-w-2xl mx-auto">
            Encuentra respuestas a las consultas más comunes sobre nuestros productos y servicios.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl shadow-xl shadow-gray-700 hover:shadow-2xl overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <motion.button
                className="w-full p-6 text-left flex items-center justify-between hover:bg-gradient-to-r from-gray-50 to-gray-400 transition-colors"
                onClick={() => toggleFaq(index)}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.99 }}
              >
                <span className="font-semibold text-black pr-4">{faq.question}</span>
                <motion.div
                  animate={{ rotate: openFaq === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  {openFaq === index ? (
                    <Minus className="w-5 h-5 text-blue-500 flex-shrink-0" />
                  ) : (
                    <Plus className="w-5 h-5 text-blue-800 flex-shrink-0" />
                  )}
                </motion.div>
              </motion.button>

              <AnimatePresence>
                {openFaq === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-6 pt-2">
                      <div className="relative pl-4">
                        <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-blue-400 to-blue-900 rounded-full"></div>
                        <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-12 bg-gradient-to-r from-blue-500 to-blue-800 rounded-2xl p-8 text-center text-white shadow-xl shadow-gray-700"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          <h2 className="text-2xl font-bold mb-4">¿No encontraste lo que buscabas?</h2>
          <p className="mb-6 opacity-90">
            Nuestro equipo de expertos está listo para responder cualquier pregunta específica que tengas.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.button
              onClick={() => window.open('https://wa.me/573183473820?text=Cordial%20Saludo%20Soporte%20InverdronJGW,%20Tengo%20una%20duda%20referente%20a%20FAQ.', '_blank')}
              className="bg-white text-blue-500 px-6 py-3 rounded-lg font-semibold shadow-xl shadow-gray-700 hover:shadow-2xl transition-shadow"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              💬 Chatea con nosotros
            </motion.button>
            <motion.a
              href="tel:+573183473820"
              className="bg-white/20 border-2 border-white text-white px-6 py-3 rounded-lg font-semibold shadow-xl shadow-gray-700 hover:shadow-2xl hover:bg-white hover:text-blue-500 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <PhoneCall className="inline-block text-gradient-to-r from-yellow-500 to-yellow-800 w-4 h-4 mr-2" />
              Llámanos ahora
            </motion.a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FAQPage;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.